import React, { useState, useEffect } from 'react';
import './everyday-rewards-card-number.scss';
import { Icon } from '@ampol/design-system';

/**
 * Everyday Rewards Card Number component
 * @returns JSX Element
 */
const EverydayRewardsCardNumber = ({ value }) => {
  const [showCardNumber, setShowCardNumber] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    if (showCardNumber) {
      setDisplayValue(value);
    } else {
      // TO DO: Confirm business requirements as card number from API does not conform with design
      const obfuscatedValue = value ? value.substring(0, 4) + '*****' + value.slice(-4) : '';
      setDisplayValue(obfuscatedValue);
    }
  }, [showCardNumber]);

  const onCardNumberToggle = () => {
    setShowCardNumber(!showCardNumber);
  };

  return <>
    <div className="everyday-rewards-card-number__container">
      <div className="everyday-rewards-card-number__label">
        Card Number
      </div>
      <div className="everyday-rewards-card-number__input-container">
        <div>{displayValue}</div>
        <button className="everyday-rewards-card-number__button" onClick={onCardNumberToggle}>
          <Icon url={showCardNumber ? '/icons/eye-off.svg' : '/icons/eye.svg'}/>
        </button>
      </div>
    </div>
  </>;
};

export default EverydayRewardsCardNumber;
